const text = {
  // Blok: kop en structuur
  header: 'Tweestapsverificatie',
  primaryVerificationMethod: 'Methode',
  cannotSeeWhileImpersonating:
    'Je kunt deze blok niet zien terwijl je een andere gebruiker imiteert.',
  userHasMfa: 'Gebruiker heeft tweestapsverificatie ingeschakeld',
  userDoesNotHaveMfa: 'Gebruiker heeft tweestapsverificatie niet ingeschakeld',

  // Authenticator app (TOTP)
  authenticatorApp: 'Authenticator-app',
  ariaTotpSettings: 'Instellingen voor authenticator-app',
  active: 'Actief',
  addDevice: 'Authenticator-app toevoegen',
  replaceDevice: 'Vervangen',
  addTotp: 'Instellen',
  disableMfa: 'Uitschakelen',
  ctaSetupTotp: 'Tweestapsverificatie instellen',
  ctaSetupTotpDescription:
    'Gebruik een authenticator-app om eenmalige codes te genereren en je account extra te beveiligen.',

  // Back-up phone and SMS rows
  backupMethodHeader: 'Backup telefoonnummer',
  phoneNumberLabel: 'Telefoonnummer',
  smsVerificationLabel: 'SMS-verificatie',
  changePhone: 'Wijzigen',
  verifyPhone: 'Telefoonnummer verifiëren',
  addPhone: 'Add backup',
  ctaVerifyPhoneNumber: 'Telefoonnummer verifiëren',
  ctaVerifyPhoneNumberDescription:
    'Verifiëer je backup telefoonnummer om het te activeren.',
  ariaPhoneSettings: 'Backup telefoonnummer wijzigen',
  ctaAddPhone: 'Backup toevoegen',
  ctaAddPhoneDescription:
    'Voeg een backup toe zodat je je account kunt herstellen als je je authenticator-app kwijtraakt.',

  // Shared status labels
  verified: 'Geverifieerd',
  notConfigured: 'Niet ingesteld',
  notVerified: 'Niet geverifieerd',
  notActivated: 'Niet ingeschakeld',
  notAvailable: 'Niet beschikbaar',

  // SMS verification in/out
  ctaEnableSms: 'SMS-verificatie inschakelen',
  ctaEnableSmsDescription:
    'Schakel SMS in om je backup telefoonnummer te activeren als herstelmethode.',
  enableSms: 'Inschakelen',
  enableSmsSuccess: 'SMS-verificatie succesvol ingeschakeld',
  enableSmsErrorMessage: 'SMS-verificatie inschakelen is niet gelukt.',
  enableSmsRequiresTotp:
    'Schakel eerst de authenticator-app in voordat je SMS-verificatie kunt gebruiken.',
  disableMfaErrorMessage: 'Tweestapsverificatie uitschakelen is niet gelukt.',

  // Confirm: MFA / authenticator removal
  confirmDeleteTitle: 'Tweestapsverificatie verwijderen',
  confirmDeleteTotpWithoutSmsBody:
    'Weet je het zeker? Dit verwijdert je authenticator-app en maakt je account minder veilig.',
  confirmDeleteTotpWithSmsBody:
    'Weet je het zeker? Dit verwijdert ook je backup telefoonnummer en maakt je account minder veilig.',
  deleteTotpOtpInstruction:
    'Bevestig met de code uit je authenticator-app om tweestapsverificatie te kunnen uitschakelen.',
  deleteTotpCodeLengthError: 'Voer een 6-cijferige code in.',
  deleteTotpInvalidCode: 'Ongeldige verificatiecode. Probeer het opnieuw.',
  confirmDeleteButton: 'Verwijderen',
  cancelButton: 'Annuleren',
  deleteSuccessMessage: 'Tweestapsverificatie succesvol verwijderd',
  cannotRemove:
    'Apparaat verwijderen niet toegestaan omdat het account tweestapsverificatie vereist.',
};

export default text;
